import { FastApiAxiosInstance } from './axiosInstances';

const time = {
  now: () => {
    const host =
      process.env.NODE_ENV === 'development' ? import.meta.env.VITE_TIANGONG_URL : window.EEVEE_TIANGONG_HOST;
    return FastApiAxiosInstance.get(`${host}/time/now`);
  },
};
export default time;
